import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
		},
		container: {
			position: 'relative',
			paddingBottom: '56.25%',
		},
		content: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			'& iframe': {
				width: '100%',
				height: '100%',
			},
		},
	},
	{ name: 'Video-VideoBlock' },
)

export default useStyles
